const CLIENTS = [
  [
    ["Christie's New York", "https://www.christies.com/"],
    ["Matter Surfaces", "https://mattersurfaces.com/"],
    ["Barney's New York"],
    ["Dark Matter Audio Labs", "https://darkmatteraudiolabs.com/"],
    ["Grown Brilliance", "https://grownbrilliance.com/"],
    ["Style Me Pretty", "https://www.stylemepretty.com/"],
    ["Rainbow Shops", "https://www.rainbowshops.com/"],
  ],
  [
    ["MoMA Design Store", "https://store.moma.org/"],
    ["Florence by Mills", "https://www.florencebymills.com/"],
    ["Dwell", "https://www.dwell.com/"],
    ["Boast USA", "https://boastusa.com/"],
    ["David Yurman", "https://www.davidyurman.com/"],
    ["SDN Brooklyn", "https://www.sdnbrooklyn.com/"],
    ["Manmade Mastering", "https://manmademastering.de/"],
  ],
  [
    ["Etnie Shoes", "https://etnies.com/"],
    ["Reebok", "https://www.reebok.com/"],
    ["My Dearest World"],
    ["Allen Atelier"],
    ["Weppner Architects", "https://www.weppnerarchitects.com/"],
    ["Anderson Windows & Doors", "https://www.andersenwindows.com/"],
    ["Interior Design Magazine", "https://interiordesign.net/"],
  ],
];

const THANKS = [
  [
    ["Sharon Ryan", "Stylist", "https://www.halleyresources.com/stylists/506445/sharon-ryan/bio"],
    ["Jenn Rogein", "Stylist", "https://jennrogien.com/"],
    ["Shelley Rosario", "Stylist", "https://www.shelleyrosario.com/"],
  ],
  [
    ["Nalin Springer", "Stylist", "https://nalinspringer.com/"],
    ["Phaedra Paulson", "Stylist", "https://www.phaedraelizabeth.com/"],
    ["Tara Lindis-Corbell", "Copywriter"],
  ],
  [
    ["Erica Thorpe", "Retoucher", "https://www.erica-thorpe.com/"],
    ["Greg Kopsachilis", "Retoucher"],
  ],
];

const Maybe = ({ href, children }) =>
  href ? <a href={href} target="_blank" rel="noopener noreferrer">{children}</a> : children;

export const ClientsPopup = ({ onClose }) => (
  <div className="jt-pop-clients" onClick={onClose} data-testid="clients-popup">
    <div className="jt-pop-clients__box" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Clients">
      <h2 className="jt-pop-h">Clients we've worked with</h2>
      <div className="jt-pop-cols">
        {CLIENTS.map((col, i) => (
          <div className="jt-pop-col" key={i}>
            {col.map(([name, href]) => (
              <h3 key={name}><Maybe href={href}>{name}</Maybe></h3>
            ))}
          </div>
        ))}
      </div>
      <h2 className="jt-pop-h">Special Thanks to</h2>
      <div className="jt-pop-cols">
        {THANKS.map((col, i) => (
          <div className="jt-pop-col jt-pop-col--thanks" key={i}>
            {col.map(([name, role, href]) => (
              <h3 key={name}>
                <Maybe href={href}>{name}, <span className="jt-pos">{role}</span></Maybe>
              </h3>
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const TextPopup = ({ text, body, open, onClose }) => {
  const [heading, ...paras] = String(body || "").split(/\n\s*\n/).map((s) => s.trim()).filter(Boolean);
  return (
    <section
      className={`jt-pop-text ${open ? "is-open" : ""}`}
      onClick={onClose}
      aria-label="About this work"
      aria-hidden={!open}
      data-testid="text-popup"
    >
      {text && <p>{text}</p>}
      {heading && (
        <article className="jt-pop-article" data-testid="text-popup-article">
          <h2>{heading}</h2>
          {paras.map((t, i) => <p key={i}>{t}</p>)}
        </article>
      )}
    </section>
  );
};
